import { Select } from 'antd';
import React, { useMemo, useState } from 'react'
import AuthService from '../../Helpers/Auth.service';
import JWTService from '../../Helpers/JWT.service';
import api from '../../Interceptors/Interceptor';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const VariantPriceSection = (
    { productVariants,
        price,
        mrp,
        productId,
        totalQuantity, setTotalQuantity,
        isDetailsProduct
    }) => {
    const [priceIndex, setPriceIndex] = useState(0)

    const selectVariant = useMemo(() => productVariants[priceIndex], [productVariants, priceIndex]);
    // console.log("selectVariant ", selectVariant);
    const navigate = useNavigate();


    async function AddSingleToCart(e, id) {
        let usersId = localStorage.getItem('userid');
        let token = localStorage.getItem('token');
        const productsId = id;

        if (token == null) {
            navigate('/login');
            return;
        }

        var requestOptions = {
            method: 'GET',
            headers: AuthService.getHeadersWithAuthToken(),
        };

        if (JWTService.isTokenExpired(token, 30)) {
            await new AuthService().refreshAccessToken();
            token = localStorage.getItem('token');
        }

        try {
            const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/api/app/Products/${productsId}`, requestOptions);
            const data = response.data;
            const Pname = data.name;
            const Pprice = data.price;

            const raw = JSON.stringify({
                "productsId": productsId,
                "usersId": usersId,
                "productVariantsId": selectVariant?.id || 0,
                "productVariantPriceId": selectVariant?.productVariantPrice?.id || 0,
                "packing": "packaging",
                "price": Pprice,
                "qty": 1,
            });

            const requestOptions2 = {
                method: 'POST',
                headers: AuthService.getHeadersWithAuthToken(),
                body: raw,
            };

            const response4 = await api.post(`${process.env.REACT_APP_API_BASE_URL}/api/app/Carts`, raw, requestOptions2);

            if (response4.status === 200 || response4.status === 201) {
                toast.success(`${Pname} added to cart!`, {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setTotalQuantity(totalQuantity + 1);
                return 0;
            } else {
                toast.error('Please Login To add cart', {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                navigate('/login');
                return;
            }
        } catch (error) {
            console.error(error);
            // Handle error as needed
        }
    }



    return <>
        <div className='d-flex '>
            <div className="product-price" style={{

                fontWeight: 700,
                fontSize: 18,
                color: "#3bb77e"
                ,
                margin: 0
            }}>
                <span>&#8377; {selectVariant?.id ? selectVariant?.productVariantPrice?.salesPrice : price}</span>
                {
                    (parseFloat(selectVariant?.id ? selectVariant?.productVariantPrice?.mrp : mrp) !== 0 && (selectVariant?.id ? selectVariant?.productVariantPrice?.mrp : mrp) !== price) &&
                    <span className="old-price">&#8377; {selectVariant?.id ? selectVariant?.productVariantPrice?.mrp : mrp}</span>}
            </div>
            &nbsp;
            <Select
                value={priceIndex}
                style={{
                    // width: 120,

                }}
                className='variant-selection'
                onChange={e => {
                    console.log({ e });
                    setPriceIndex(e);
                }}
                options={[

                    ...productVariants
                        .filter(c => c.productVariantPrice?.id)
                        .map((data, i) => {
                            // console.log({ data });
                            return {
                                value: i,
                                label: data.name,
                            }
                        }),

                ]}
            />
        </div>


        {isDetailsProduct ?
            <div className="detail-extralink mb-50">
                <div className="product-extra-link2">

                    <button
                        onClick={(e) => {
                            AddSingleToCart(e, productId);
                        }}
                        type="button"
                        className="button button-add-to-cart"
                    >
                        <i className="fi-rs-shopping-cart" />
                        Add to cart
                    </button>

                </div>
            </div> :
            <div className="product-card-bottom">
                <div className="qty-select">
                    <div className="add-cart">
                        <a
                            className="add"
                            onClick={(e) => AddSingleToCart(e, productId)}
                        >
                            <i className="fi-rs-productping-cart mr-5" />
                            Add to cart
                        </a >
                    </div >
                </div >
            </div >


        }
        {/* <div className='product-card-bottom'>
            <div className='qty-select'>
                <div className="add-cart">
                    <a className="add"

                        onClick={(e) => {

                            AddSingleToCart(e, productId)
                        }}  >

                        <i className="fi-rs-shopping-cart mr-5" />
                        Add to cart</a>
                </div>
            </div>
        </div> */}

    </>
}


export default VariantPriceSection;